import { useMemo } from 'react';
import { DateTimeFormatOptions } from '@24i/nxg-core-utils';
import { useFeature } from '../../context/AppSettingsData';

const detectIs12HourClock = (timeFormat?: string): boolean =>
    Boolean(timeFormat && (timeFormat.includes('a') || timeFormat.includes('h')));

export const useTimeFormat = (): DateTimeFormatOptions => {
    const localization = useFeature('localization');
    return useMemo(
        () => ({
            ...localization,
            is12HourClock: detectIs12HourClock(localization?.timeFormat),
        }),
        [localization]
    );
};
